module.exports = __webpack_public_path__ + "h5/img/funv-bottom-image.01dcab07.jpg";